import { laptopMediumMax } from '@propertypal/shared/src/constants/mediaQueries';
import { MapContent } from '@propertypal/web-app/src/components/property/MarketTrendsModal.style';
import styled from 'styled-components';
import { Container as LineChart } from '../charts/LineChart.style';
import { Box } from '../layout';

export const Container = styled.div`
  margin-top: 60px;
`;

export const ChartContent = styled(MapContent)`
  flex-direction: column;
  gap: 30px;
  align-items: center;
  width: 100%;

  @media (${laptopMediumMax}) {
    max-width: 100%;
    gap: 10px;
    margin-bottom: 0px;

    ${LineChart} {
      margin-top: 10px;
    }
  }
`;

export const Checkboxes = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 18px;
  align-items: center;
  margin: 0px auto 15px auto;
  width: 100%;
  justify-content: center;

  label {
    font-weight: normal;
    font-size: 12px;
  }

  @media (${laptopMediumMax}) {
    margin-top: 15px;
    margin-bottom: 0px;
  }
`;

export const Disclaimer = styled(Box)`
  text-align: left;
`;
